import React, { useEffect } from "react";
import { connect } from "react-redux";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";
import { firebaseAuth } from "../../../../firebase";
import { signOut } from "firebase/auth";

function Logout(props) {
  useEffect(() => {
    const performLogout = async () => {
      console.log('🔴 Logging out...');
      
      // Clear everything
      localStorage.clear();
      sessionStorage.clear();
      
      // Sign out from Firebase
      try {
        await signOut(firebaseAuth);
      } catch (error) {
        console.error('Firebase signout error:', error);
      }
      
      // Clear Redux
      props.logout();
      
      // ✅ Hard redirect - no React Router involved
      window.location.href = '/auth/login';
    };

    performLogout();
  }, [props]);

  // Always show loading
  return <LayoutSplashScreen />;
}

export default connect(null, auth.actions)(Logout);